import InlineImageCarousel from './InlineImageCarousel';
import InlinePostImage from './InlinePostImage';

export default function ImageDisplay({
  groupId,
  pictures,
  previewMode,
  handleImageRemove,
  handleCaptionChange,
}) {
  const internalDelete = (groupId, pictureId) => {
    handleImageRemove?.(groupId, pictureId);
  };

  if (!pictures?.length) return null;

  if (pictures.length === 1) {
    const img = pictures[0];

    return (
      <InlinePostImage
        groupId={groupId}
        image={img}
        previewMode={previewMode}
        onRemove={() => internalDelete(groupId, img.pictureId)}
        onCaptionChange={handleCaptionChange}
      />
    );
  }
  return (
    <InlineImageCarousel
      groupId={groupId}
      images={pictures}
      previewMode={previewMode}
      onRemoveImage={internalDelete}
      onCaptionChange={handleCaptionChange}
    />
  );
}
